<div class="page">
  <div class="header-wrapper d-flex align-items-center justify-content-between">
    <h1>{{ title }}</h1>
    <div class="profile-wrap d-flex align-items-center">
      <app-profile-section></app-profile-section>
    </div>
  </div>
  <div class="top-bar" [class.no-pointer]="loading">
    @if (addBtnText) {
      <app-button
        classes="primary-default"
        icon="plus-round"
        [disabled]="false"
        [linkHref]="createLink"
        [submitting]="false"
        [text]="addBtnText"
      ></app-button>
    }
  </div>
  <div class="content-wrap">
    <ng-content></ng-content>
  </div>
</div>
